<div *ngIf="category" class="settings-detail-page">
  <div class="settings-header">
    <button mat-icon-button class="back-button" (click)="goBack()" aria-label="Zurück">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ category.title }}</h1>
  </div>

  <form *ngIf="settingsForm" [formGroup]="settingsForm" class="settings-form">
    <div class="settings-item-list">
      <div class="setting-item">
        @for (item of category.items; track $index) {
          @switch (item.type) {
            @case ('text') {
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <mat-label>{{ item.title }}</mat-label>
                <input matInput [formControlName]="item.key" type="text" />
              </mat-form-field>
            }
            @case ('password') {
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <mat-label>{{ item.title }}</mat-label>
                <input matInput [formControlName]="item.key" type="password" />
              </mat-form-field>
            }
            @case ('textarea') {
              <mat-form-field subscriptSizing="dynamic">
                <mat-label>{{ item.title }}</mat-label>
                <textarea matInput [formControlName]="item.key"></textarea>
              </mat-form-field>
            }
            @case ('email') {
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <mat-label>{{ item.title }}</mat-label>
                <input #email matInput [formControlName]="item.key" type="email" />
              </mat-form-field>
              @if (showEmailError$.value) {
                <mat-error> Die E-Mail ist bereits vergeben. </mat-error>
              }
            }
            @case ('username') {
              <mat-form-field appearance="fill" subscriptSizing="dynamic">
                <mat-label>{{ item.title }}</mat-label>
                <input #username matInput [formControlName]="item.key" type="text" />
              </mat-form-field>

              @if (showUsernameError$.value) {
                <mat-error> Der Benutzername ist bereits vergeben. </mat-error>
              }
            }
            @case ('picture') {
              <div class="picture-item-container">
                <img
                  class="profilePic"
                  #profilBild
                  [src]="environment.backend + dataSource[item.key]"
                  alt="Profilbild"
                />
                <button mat-flat-button (click)="openFilePicker()">Profilbild ändern</button>
              </div>

              <input type="file" #fileInput hidden (change)="onFileSelected($event)" />
            }

            @case ('navigation') {
              <a class="item-navigation" [routerLink]="[item.key]">
                {{ item.title }}
              </a>
            }

            @case ('navigation-external') {
              <div class="navigation-external">
                <a [href]="item.key" target="_blank">
                  {{ item.title }}
                </a>
                <mat-icon class="external-link-icon">open_in_new</mat-icon>
              </div>
            }
            @default {
              <p>Unimplemented type {{ item.type }}</p>
            }
          }
        }
      </div>
    </div>

    <div class="form-actions">
      <button mat-stroked-button type="button" (click)="discard()">Verwerfen</button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        (click)="save()"
        [disabled]="!settingsForm.dirty || settingsForm.invalid"
        >Speichern</button
      >
    </div>
  </form>
</div>
